"use client";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@repo/ui";
import { Button } from "@repo/ui";
import { Book, BookOpen, HelpCircle } from "lucide-react";
import Link from "next/link";

import { cn } from "@/lib/utils";

interface DocsDropdownProps {
  className?: string;
  isUserDashboard?: boolean;
  side?: "top" | "right" | "bottom" | "left";
}

export function DocsDropdown({
  className,
  isUserDashboard: _isUserDashboard = false,
  side,
}: DocsDropdownProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          className={cn(
            "border-border text-muted-foreground hover:border-primary hover:bg-accent hover:text-foreground size-8 rounded-full p-0 shadow-none transition-colors",
            className,
          )}
        >
          <Book className="size-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        className="border-border bg-background w-72 rounded-lg shadow-lg"
        align="end"
        side={side}
      >
        <DropdownMenuItem asChild>
          <Link
            href="/docs/experts"
            className="flex cursor-pointer items-center gap-3"
          >
            <BookOpen className="size-4" />
            <div className="flex-1">
              <div className="font-medium">Expert Docs</div>
              <div className="text-muted-foreground text-xs">
                Guides for experts and panelists
              </div>
            </div>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link
            href="/docs/researchers"
            className="flex cursor-pointer items-center gap-3"
          >
            <BookOpen className="size-4" />
            <div className="flex-1">
              <div className="font-medium">Researcher Docs</div>
              <div className="text-muted-foreground text-xs">
                Guides for researchers running studies
              </div>
            </div>
          </Link>
        </DropdownMenuItem>
        <DropdownMenuItem asChild>
          <Link href="/help" className="flex cursor-pointer items-center gap-3">
            <HelpCircle className="size-4" />
            <div className="flex-1">
              <div className="font-medium">Help Center</div>
              <div className="text-muted-foreground text-xs">
                Communities and direct support
              </div>
            </div>
          </Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
